import React from "react";
import "./Cupboard.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Cupboard = ({ shelves, isOpen }) => {
    const raw = Array.isArray(shelves) ? shelves : [];
    const connected = raw.length > 0;

    const mainDiv = (
        <div className="cupboard">
            <div className={`cupboard-status ${isOpen ? 'open' : 'closed'}`}>
                Cupboard is {isOpen ? 'Open' : 'Closed'}
            </div>
            <div className="cupboard-frame">
                {raw.map((isOccupied, idx) => (
                    <div key={idx} className="shelf">
                        <div className={`slot ${isOccupied ? 'occupied' : 'empty'}`}>
                            <div className="placeholder">
                                {isOccupied ? 'Occupied' : 'Empty'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <RiddleCard title={"Cupboard"} allSolved={null} mainInfo={mainDiv} connected={connected} index={0} />
    );
};

export default Cupboard;